const state = {
  aboutInfo: [
    "میرکاتێک کۆمپانیایەکی تەکنەلۆجییای زانیارییە کە لە سلێمانی – عێڕاق دامەزراوە، ئێمە تایبەتمەندین لە بوارەکانی (وێبسایت، مۆبایل ئەپڵیکەیشن، داتابەیس، خزمەتگەزاری نێتۆرک وە بەڕێوەبردنی سۆشیاڵ میدیا).",
    "ميركا تیک هي شركة لتكنولوجيا المعلومات والتي مقرها في السليمانية - العراق ، نحن متخصصون (تطوير الويب ، تطبيقات الهاتف المحمول ، نظام إدارة قواعد البيانات ، خدمات الشبكة و إدارة وسائل التواصل الاجتماعي).",
    "Mirka Tech is an information technology company based in Sulaimanyiah - Iraq, we are specialized (web development, Mobile application, Database management system, network services and social media managment)."
  ],
  contactusInfo: {
    location: [
      [
        "سلێمانی - بەختیاری - هەندرێن -گەڕەکی ٩- شەقامی ٢٥ - تەلاری ژمارە ١",
        "هندرین (بختياري) حي 9 ، زقاق 25 ، مبنى رقم 1 ، السليمانية ، العراق.",
        "Handren (Bakhtiari) District 9, Alley 25, Building no.1, As Sulaymaniyah, Iraq"
      ]
    ],
    phone: ["(+964) 772 995 1111", "053 5747"],
    email: ["info@mirkatech.com"],
    sm: {
      fb: "https://www.facebook.com/mirkatechnology/",
      in: "https://www.instagram.com/mirkatech/?igshid=2hxcgu8yukof"
    }
  }
};

const getters = {
  aboutInfo: state => state.aboutInfo,
  contactusInfo: state => state.contactusInfo
};

const actions = {
  // changeLanguage({ commit }, newLang) {
  //   commit("changeLanguage", newLang);
  // },
};

const mutations = {
  // changeLanguage: (state, newLang) => {
  //   state.language = newLang;
  // }
};

export default {
  state,
  getters,
  actions,
  mutations
};
